import isEmpty from 'lodash/isEmpty';
import arraySort from 'array-sort';

export function generateTeamOptions(teams) {
  const options = teams.map(team => ({
    value: team,
    label: team,
  }));
  return arraySort(options, 'label');
}

export function generateSeasonOptions(team, seasons) {
  const options = isEmpty(team)
    ? []
    : seasons.map(season => ({
      value: season,
      label: season,
    }));
  return arraySort(options, 'label');
}
